import type { PricingVersionFormat, PricingVersionTuple } from '../../model/model.ts'

type FrMrgaPricingVersionFormat = PricingVersionFormat<'fr-mrg-axeria'>

export const frMrgaPricingVersions = [
  ['pricing-fr-mrg-axeria-1.0.0-2026-09-28', { label: 'Version 1' }],
  ['pricing-fr-mrg-axeria-1.0.1-2027-01-01', { label: 'Version 1.0.1 - Terrorism tax €8.50' }],
] as const satisfies PricingVersionTuple<FrMrgaPricingVersionFormat>[]

export type FrMrgaPricingVersion = (typeof frMrgaPricingVersions)[number][0]
